import * as React from 'react';

import { WithStyles, withStyles } from '@material-ui/core';

import {
  EModule,
  FallbackContainerAccessDenied,
  IContainerAccessDeniedProps,
  ModuleWrapper,
} from '@lumahealthhq/ui-common';

import styles from './AccessDeniedPage.styles';

const ContainerAccessDenied = React.lazy<React.ComponentType<IContainerAccessDeniedProps>>(() =>
  import('remote_auth/ContainerAccessDenied'),
);

interface IAccessDeniedPage extends WithStyles<typeof styles> {}

function AccessDeniedPage(props: IAccessDeniedPage) {
  const { classes } = props;

  return (
    // TODO @phelipe-ohlsen do we need these divs? it looks like classes aren't being passed
    // Note that in case of updating styles we can pass the sx prop to the ContainerAccessDenied
    <div className={classes.root}>
      <div className={classes.container}>
        <ModuleWrapper module={EModule.ContainerAccessDenied} fallback={<FallbackContainerAccessDenied />}>
          <ContainerAccessDenied />
        </ModuleWrapper>
      </div>
    </div>
  );
}

export default withStyles(styles)(AccessDeniedPage);
